import { Link } from 'react-router-dom';
import { useSettingsStore } from '../../store/settingsStore';
import { useT } from '../../hooks/useT';
import logo from '../../assets/logo140.png';

/**
 * Shared nav header for public pages (login, register, pricing, etc.)
 * `hideAuth` — hides Sign In / Get Started buttons (e.g. on the login page itself)
 */
export default function PublicNav({ hideAuth = false }) {
  const { language, toggleLanguage } = useSettingsStore();
  const t = useT();

  return (
    <nav className="border-b border-surface-border px-6 py-4 sticky top-0 z-10 bg-surface/80 backdrop-blur-md">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src={logo} alt="Plannizzi AI" className="h-10 w-auto" />
          <div className="flex flex-col leading-tight">
            <span className="font-bold text-base text-primary">Plannizzi AI</span>
            <span className="text-xs text-slate-500 hidden sm:block">{t('brand.slogan')}</span>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <button
            onClick={toggleLanguage}
            className="flex items-center gap-1.5 text-slate-400 hover:text-slate-200 text-sm transition-colors px-2 py-1 rounded-lg hover:bg-surface-card border border-transparent hover:border-surface-border"
            title={language === 'en' ? 'Mudar para Português' : 'Switch to English'}
          >
            🌐 {language === 'en' ? 'PT' : 'EN'}
          </button>
          {!hideAuth && (
            <>
              <Link to="/pricing" className="text-slate-400 hover:text-slate-200 text-sm transition-colors hidden sm:block">
                {t('landing.nav.pricing')}
              </Link>
              <Link to="/login" className="btn-ghost text-sm">{t('landing.nav.sign_in')}</Link>
              <Link to="/register" className="btn-primary text-sm">{t('landing.nav.get_started')}</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
